// extracted by mini-css-extract-plugin
module.exports = {"fromLay":"Form_fromLay__2F-5c","push_btn":"Form_push_btn__1tFNT","add_btn_":"Form_add_btn___KSwY5","selectIconCss":"Form_selectIconCss__3V0zV"};